<template>
  <v-container class="pa-0 ma-0">
    <v-dialog v-model="dialog" persistent max-width="60vw">
      <v-card max-width="60vw">
        <v-card-text class="pt-8">
          <v-row>
            <v-col class="widgetsList--text">
              <span :style="{fontSize: '17px', letterSpacing: '1px'}">
                {{ labels.title.toUpperCase() }}
              </span>
            </v-col>
          </v-row>
          <v-divider />
          <v-row justify="space-around">
            <v-col cols="12" md="3" class="pt-6">
              <v-row class="pt-8 pl-md-5 pl-lg-5" align="center" align-content="center">
                <v-col
                  cols="12" sm="6" md="12"
                  align="center">
                  <v-avatar
                    tile color="blue-grey lighten-5" :size="avatarSize">
                    <v-img v-if="avatar" :src="getAvatar()" />
                    <v-icon v-else dark size="120">
                      mdi-account
                    </v-icon>
                  </v-avatar>
                </v-col>
                <v-col cols="12" sm="6" md="12">
                  <v-btn
                    outlined height="42" :style="{fontSize: '12px'}"
                    width="100%" color="blue-grey lighten-2" @click="handleFileImport">
                    {{ labels.chooseFile }}
                  </v-btn>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-divider v-if="isSmallAndDown" />
                </v-col>
              </v-row>
              <input
                ref="uploader"
                class="d-none"
                type="file"
                @change="onFileChanged">
            </v-col>
            <v-col cols="12" md="9" class="pl-md-8 pl-lg-8">
              <v-form ref="newAccountForm" v-model="isFormValid">
                <v-row align="center" justify="center" class="pt-md-8 pt-lg-8">
                  <v-col cols="12" sm="6">
                    <BaseTextField
                      v-model="username"
                      :label="labels.username" type="text" maxlength="255"
                      :rules="[required(), maximum(255)]"
                      append-icon="mdi-account-outline"
                      :login="true" />
                  </v-col>
                  <v-col cols="12" sm="6">
                    <BaseTextField
                      v-model="password"
                      :label="labels.password" :type="showPass ? 'text' : 'password'"
                      :rules="[required(), maximum(255), minimum(5)]"
                      :append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
                      :login="true"
                      @click:append="showPass = !showPass" />
                  </v-col>
                </v-row>
                <v-row align="center" justify="center">
                  <v-col cols="12" sm="6">
                    <BaseTextField
                      v-model="name"
                      :label="labels.name" type="text" maxlength="255"
                      :rules="[required(), maximum(255)]" append-icon="mdi-account-outline"
                      :login="true" />
                  </v-col>
                  <v-col cols="12" sm="6">
                    <BaseTextField
                      v-model="surname"
                      :label="labels.surname" type="text" maxlength="255"
                      :rules="[required(), maximum(255)]" append-icon="mdi-account-outline"
                      :login="true" />
                  </v-col>
                </v-row>
                <v-row align="center" justify="center">
                  <v-col cols="12" sm="6">
                    <BaseTextField
                      v-model="phone"
                      :label="labels.phone" type="text" maxlength="255"
                      :rules="[regex('^([+]*[0-9]*)$')]" append-icon="mdi-phone-outline"
                      :login="true" />
                  </v-col>
                  <v-col cols="12" sm="6">
                    <BaseTextField
                      v-model="email"
                      :label="labels.email"
                      type="text"
                      :rules="[required(), regex('^([\\w\\-\\.]+@([\\w\\-]+\\.)+[\\w\\-]{2,4})*$')]"
                      maxlength="255"
                      append-icon="mdi-email-outline"
                      :login="true" />
                  </v-col>
                </v-row>
                <v-divider />
                <v-row class="pt-8">
                  <v-col cols="12" sm="6">
                    <BasePrimaryBtn :title="labels.save" :disabled="!isFormValid" @click="saveUser" />
                  </v-col>
                  <v-col cols="12" sm="6">
                    <BaseSecondaryBtn :title="labels.cancel" @click="closeDialog" />
                  </v-col>
                </v-row>
              </v-form>
            </v-col>
            <v-spacer />
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="error" color="error" multi-line>
      {{ labels[messageCode] }}
      <v-btn color="white" text @click="error = false">
        {{ labels.close }}
      </v-btn>
    </v-snackbar>
    <v-snackbar v-model="success" color="success" multi-line>
      {{ labels.success }}
      <v-btn color="white" text @click="success = false">
        {{ labels.close }}
      </v-btn>
    </v-snackbar>
  </v-container>
</template>
<script>
import axios from 'axios'
import rules from '@/mixin/rules.js'
export default {
  name: 'NewAccount',
  mixins: [rules],
  props: { openDialog: { type: Boolean, default () { return false } } },
  data () {
    return {
      dialog: false,
      isFormValid: false,
      avatar: null,
      username: '',
      password: '',
      showPass: false,
      name: '',
      surname: '',
      phone: '',
      email: '',
      error: false,
      messageCode: null,
      success: false,
      isSelecting: false,
      selectedFile: null,
    }
  },
  computed: {
    labels () {
      return this.getLabels(this.$store.getters.getLanguage).newAccount
    },
    organisationId () {
      return this.$store.getters.getOrganisationId
    },
    isSmallAndDown () {
      return this.$vuetify.breakpoint.smAndDown
    },
    avatarSize () {
      if (this.isSmallAndDown) {
        return '100%'
      }
      if (this.$vuetify.breakpoint.md) {
        return '100%'
      }
      return '75%'
    },
  },
  watch: {
    openDialog (newValue) {
      if (newValue) {
        this.dialog = true
      }
    },
  },
  methods: {
    closeDialog () {
      this.$emit('new-account-canceled')
      this.avatar = null
      this.username = ''
      this.password = ''
      this.name = ''
      this.surname = ''
      this.phone = ''
      this.email = ''
      this.$refs.newAccountForm.resetValidation()
      this.dialog = false
    },
    async saveUser () {
      const body = {
        type: 'users',
        user: {
          active: true,
          avatar: this.avatar,
          organisationadmin: false,
          email: this.email,
          name: this.name,
          password: this.password,
          phone: this.phone,
          surname: this.surname,
          username: this.username,
          organisationfk: this.organisationId,
          fromgdiidp: 0,
          otherfields: '',
        },
      }
      try {
        const res = await axios.post('/portalAdd', body)
        if (res.data.success) {
          this.success = true
          this.avatar = null
          this.username = ''
          this.password = ''
          this.name = ''
          this.surname = ''
          this.phone = ''
          this.email = ''
          this.$refs.newAccountForm.resetValidation()
          this.closeDialog()
        } else if (res.data.message.startsWith('There is already an user with username')) {
          this.error = true
          this.messageCode = 'usernameError'
        } else if (res.data.message.startsWith('There is already an user with email')) {
          this.error = true
          this.messageCode = 'emailError'
        } else {
          this.error = true
          this.messageCode = 'error'
        }
      } catch (error) {
        this.error = true
        this.messageCode = 'error'
        console.error(error)
      }
    },
    handleFileImport () {
      this.isSelecting = true
      // After obtaining the focus when closing the FilePicker, return the button state to normal
      window.addEventListener('focus', () => {
        this.isSelecting = false
      }, { once: true })
      // Trigger click on the FileInput
      this.$refs.uploader.click()
    },
    onFileChanged (e) {
      const reader = new FileReader()
      reader.readAsDataURL(e.target.files[0])
      reader.onload = () => {
        this.avatar = reader.result.split(',')[1]
      }
    },
    getAvatar () {
      return this.avatar ? 'data:image/jpeg;base64,' + this.avatar : null
    },
  },
}
</script>
